$(document).ready(function(){

    let searchParams = new URLSearchParams(window.location.search)
       let cartOpen = searchParams.has('cart_show');
     
       if(cartOpen){
         setTimeout(function() {
           window.updateCart();
           $(document.body).addClass('cart-sidebar-show');
   
           // Obtenha a URL atual
           let url = window.location.href;
           
           // Crie um objeto URL
           let urlObj = new URL(url);
           
           // Remova todos os parâmetros
           urlObj.search = '';
           
           // Atualize a URL no navegador
           window.history.replaceState({}, document.title, urlObj.href);
         }, 1500)
       }
     
     
     function copyToClipboard(element) {
       var $temp = $("<input>");
       var oldValue = $(element).html();
       
       $("body").append($temp);
       $temp.val($(element).html()).select();
       document.execCommand("copy");
       $(element).html("COPIADO");
       setTimeout(function(){ $(element).html(oldValue); }, 300);
       $temp.remove();
     
     } 
   
     $('cupom').click(function(){
       copyToClipboard(this);
     });



     function error_ship_ajax(msg) {
      var $input_cep = $(".zipcode-input"),
        $input_container = $(".cart-drawer__footer__row"),
        $erro_ship = $(".erro-shipping");
  
      $input_cep.val("");
      $input_container.addClass("error-input");
  
      if (msg.length > 0) {
        $erro_ship.html(msg);
      }
      setTimeout(function () {
        $input_container.removeClass("error-input");
        $erro_ship.html("");
      }, 4000);
    }
  
    function shipping_ajax() {
      var $input_cep = $(".zipcode-input"),
        $shipping_list = $(".shipping_options__list"),
        $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
        $display_shipping = $(".shipping-display__wrapper"),
        $ship_name_display = $(".shipping-rate-name"),
        $container_ship_name = $(".shipping-rate-name");
  
      var $cep = $input_cep.val().replace(/\D/g, "");
      var $validacep = /^[0-9]{8}$/;
  
      console.log($validacep.test($cep));
      if ($cep == "") {
        error_ship_ajax("Campo cep está vazio");
        return;
      }
  
      if (!$validacep.test($cep)) {
        error_ship_ajax("Cep inválido");
        return;
      }
  
      $.getJSON(
        "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
        function (dados) {
          if ("erro" in dados) {
            console.log("Erro na consulta, confira o cep e tente novamente");
            return;
          }
  
          switch (dados.uf) {
            case "AC":
              dados.uf = "Acre";
              break;
            case "AL":
              dados.uf = "Alagoas";
              break;
            case "AP":
              dados.uf = "Amapa";
              break;
            case "AM":
              dados.uf = "Amazonas";
              break;
            case "BA":
              dados.uf = "Bahia";
              break;
            case "CE":
              dados.uf = "Ceara";
              break;
            case "DF":
              dados.uf = "Distrito Federal";
              break;
            case "ES":
              dados.uf = "Espirito Santo";
              break;
            case "GO":
              dados.uf = "Goias";
              break;
            case "MA":
              dados.uf = "Maranhao";
              break;
            case "MT":
              dados.uf = "Mato Grosso";
              break;
            case "MS":
              dados.uf = "Mato Grosso do Sul";
              break;
            case "MG":
              dados.uf = "Minas Gerais";
              break;
            case "PA":
              dados.uf = "Para";
              break;
            case "PB":
              dados.uf = "Paraiba";
              break;
            case "PR":
              dados.uf = "Parana";
              break;
            case "PE":
              dados.uf = "Pernambuco";
              break;
            case "PI":
              dados.uf = "Piaui";
              break;
            case "RJ":
              dados.uf = "Rio de Janeiro";
              break;
            case "RN":
              dados.uf = "Rio Grande do Norte";
              break;
            case "RS":
              dados.uf = "Rio Grande do Sul";
              break;
            case "RO":
              dados.uf = "Rondonia";
              break;
            case "RR":
              dados.uf = "Roraima";
              break;
            case "SC":
              dados.uf = "Santa Catarina";
              break;
            case "SP":
              dados.uf = "Sao Paulo";
              break;
            case "SE":
              dados.uf = "Sergipe";
              break;
            case "TO":
              dados.uf = "Tocantins";
              break;
          }
  
          $.ajax({
            type: "GET", //rest Type
            dataType: "json", //mispelled
            url:
              "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
              $cep +
              "&shipping_address%5Bcountry%5D=" +
              "Brazil" +
              "&shipping_address%5Bprovince%5D=" +
              dados.uf,
            beforeSend: function () {
              $('.overlay-carregando').show();
            },
            success: function (msg) {
              $('.overlay-carregando').hide();
              $shipping_list.html("");
              // $ship_name_display.html(msg.shipping_rates[0].name);
              // if($('.shipping-display.value') === 0.00){
              //   $('.shipping-display.value').html("Grátis");
              // }else{
              //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
              // }
              for (i = 0; i < msg.shipping_rates.length; i++) {
                let $formatedPrice;
                let $estimateShip;
                if (msg.shipping_rates[i].price === 0.0) {
                  $formatedPrice = "Grátis";
                } else {
                  $formatedPrice = Shopify.formatMoney(
                    msg.shipping_rates[i].price,
                    window.money_format
                  );
                }
                var $priceShip = msg.shipping_rates[i].price;
                if (
                  msg.shipping_rates[i].delivery_days[1] == null ||
                  msg.shipping_rates[i].delivery_days[1] === 0
                ) {
                  $estimateShip = "";
                } else {
                  $estimateShip =
                    "Em até " +
                    msg.shipping_rates[i].delivery_days[1] +
                    " dias úteis";
                }
  
                var $template =
                  '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                  msg.shipping_rates[i].name
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-$/, "")
                    .replace(/^-/, "") +
                  '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                  msg.shipping_rates[i].name
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/-$/, "")
                    .replace(/^-/, "") +
                  '" data-name="' +
                  msg.shipping_rates[i].name +
                  '" data-price="' +
                  msg.shipping_rates[i].price +
                  '" data-formatted-price="' +
                  $formatedPrice +
                  '" data-delivery="' +
                  $estimateShip +
                  '"> <span class="check"></span> <span class="text">' +
                  msg.shipping_rates[i].name +
                  " - " +
                  $formatedPrice +
                  " ("+$estimateShip+")</span> </label> </li>";
  
                $shipping_list.append($template);
  
                //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
              }
              // $display_shipping.removeClass('hidden');
              // $ship_name_display.removeClass('hidden');
              $shipping_list_container.removeClass("hidden");
            },
            error: function (erro) {
              
              $('.overlay-carregando').hide();
              console.log(
                "Erro ao consultar os fretes disponíveis, tente novamente"
              );
            },
          });
        }
      );
    }
  
    function select_ship(selected) {
      var name = selected.data("name"),
        price = selected.data("price"),
        formated_price = selected.data("formatted-price"),
        delivery = selected.data("delivery"),
        total_container = $('[data-cart-total-value]'),
        subtotal_price = $('[data-cart-subtotal]').attr('data-cart-subtotal');
  
      var $display_shipping = $(".shipping-display__wrapper"),
        $ship_name_display = $(".shipping-rate-name"),
        $ship_price_display = $(".shipping-display.value"),
        $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
        $btn_calc = $(".calculate-shipping"),
        $btn_change = $(".recalculate-shipping");
  
      var shippingNumbers = price.toString().replaceAll('.', '');
      shippingNumbers = parseInt(shippingNumbers);
      
      total_container.html(Shopify.formatMoney((parseInt(subtotal_price) + shippingNumbers), window.money_format));
      $('[data-cart-total-value]').attr('data-cart-total-value', (parseInt(subtotal_price) + shippingNumbers))

      $ship_name_display.html(name);
      $ship_price_display.html(formated_price);
      
  
      $display_shipping.removeClass("hidden");
      $ship_name_display.removeClass("hidden");
      $shipping_list_container.addClass("hidden");
      $btn_calc.addClass("hidden");
      $btn_change.removeClass("hidden");
    }
  
    function show_rate_list() {
      var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
      $shipping_list_container.removeClass("hidden");
    }
  
    function reset_ship() {
      var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
        $display_shipping = $(".shipping-display__wrapper"),
        $btn_calc = $(".calculate-shipping"),
        $btn_change = $(".recalculate-shipping"),
        $input_cep = $(".zipcode-input");
  
      $shipping_list_container.addClass("hidden");
      $display_shipping.addClass("hidden");
      $btn_change.addClass("hidden");
      $btn_calc.removeClass("hidden");
      $input_cep.val("").focus();
    }
  
    $(document).on("click", ".calculate-shipping", function (e) {
      shipping_ajax();
    });
  
    $(document).on("click", ".recalculate-shipping", function (e) {
      reset_ship();
    });
  
    $(document).on("click", "[data-shipping-change]", function (e) {
      select_ship($(this).find("input"));
    });
  
    $(document).on("click", ".show-rates-list", function (e) {
      show_rate_list();
    });
  
    $(document).on("click", "[hide-filters]", function (e) {
      $('.background-overlay').trigger('click');
    });
  
    $(document).on('input', '.zipcode-input', function(){
      if(!$(this).val().length > 0){reset_ship()}
    })

    $(document).on("click", ".column_subcategorie_title", function(e) {
      e.preventDefault();
      var $subCategory = $(this).closest('.column_subcategorie');
      var $subCategoryContainer = $(this).closest('.block-menu');
      
      if ($subCategoryContainer.find('.column_subcategorie_links').length > 0) {
          $('.column_subcategorie').not($subCategory).removeClass('open-categories');
          $subCategory.toggleClass('open-categories');
      } else {
          console.log($subCategory.attr('data-url'))
          window.location.href = $(this).attr('data-url');
      }
  });
  
  // COMPRA RÁPIDA
  $(document).on("click", "[data-add-kit-to-cart]", function () {
    const btn = $(this);
    $(btn).addClass("is-loading");
    const json = $(this).data("json");
    console.log(json);
    const quantitySelectorValue = parseInt(
      $(".form-input.quantity__input").val()
    );
    Shopify.queue = [];
    json.forEach((item) => {
      Shopify.queue.push({
        variantId: item.variant_id,
        quantity: item.quantity * quantitySelectorValue,
      });
    });
    Shopify.moveAlong = function () {
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        let dataForm =
          "quantity=" + request.quantity + "&id=" + request.variantId;
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: dataForm,
          dataType: "json",
          beforeSend: function () {
            console.log(dataForm);
          },
          success: function (line_item) {
            Shopify.moveAlong();
          },
          error: function (XMLHttpRequest, textStatus) {
            console.log("Erro ao adicionar");
          },
        };
        $.ajax(params);
      } else {
        $(btn).removeClass("is-loading");
        $(".content-compra-rapida").removeClass("is-loading");
        $(".content-compra-rapida").find("loading-overlay--custom").remove();
        $("body").removeClass("compra-rapida-aberto");
        Shopify.getCart((cartTotal) => {
          $("body").addClass("cart-sidebar-show");
          $("body").find("[data-cart-count]").text(cartTotal.item_count);
          window.updateCart(cartTotal);
        });
      }
    };
    Shopify.moveAlong();
  });
  $(".btn-quantity").on("click", function () {
    var inputElement = $(this).siblings(".qtd-input");
    var currentValue = parseInt(inputElement.val());
    var maxInventory = parseInt(inputElement.attr("data-inventory"));
    if ($(this).hasClass("plus")) {
      if (currentValue < maxInventory) {
        inputElement.val(currentValue + 1).trigger("change");
      }
    } else if ($(this).hasClass("minus")) {
      if (currentValue > 0) {
        inputElement.val(currentValue - 1).trigger("change");
      }
    }
  });
  $(".qtd-input").on("change", function () {
    var inputValue = parseInt($(this).val());
    var maxInventory = parseInt($(this).attr("data-inventory"));
    if (inputValue < 0) {
      $(this).val(0);
    } else if (inputValue > maxInventory) {
      $(this).val(maxInventory).trigger("change");
    }
  });
});

(function ($) {
  let searchParams = new URLSearchParams(window.location.search);
  let cartOpen = searchParams.has("cart_show");

  if (cartOpen) {
    $(document.body).addClass("cart-sidebar-show");
  }

  function error_ship_ajax(msg) {
    var $input_cep = $(".zipcode-input"),
      $input_container = $(".cart-drawer__footer__row"),
      $erro_ship = $(".erro-shipping");

    $input_cep.val("");
    $input_container.addClass("error-input");
    $erro_ship.addClass("show");

    // if (msg.length > 0) {
    //     $erro_ship.html(msg + " Não encontrou um frete? Entre em contato por nosso whatsapp.");
    // }
    setTimeout(function () {
      $input_container.removeClass("error-input");
      $erro_ship.removeClass("show");
      // $erro_ship.html("");
    }, 4000);
  }

  function shipping_ajax() {
    var $input_cep = $(".zipcode-input"),
      $btn_calc = $(".calculate-shipping"),
      $shipping_list = $(".shipping_options__list"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $container_ship_name = $(".shipping-rate-name");


    $btn_calc.addClass("is-loading");
    var $cep = $input_cep.val().replace(/\D/g, "");
    var $validacep = /^[0-9]{8}$/;

    console.log($validacep.test($cep));
    if ($cep == "") {
      error_ship_ajax("Campo cep está vazio");
      $btn_calc.removeClass("is-loading");
      return;
    }

    if (!$validacep.test($cep)) {
      error_ship_ajax("Cep inválido");
      $btn_calc.removeClass("is-loading");
      return;
    }

    function isDateBeforeToday(date) {
      return (
        new Date(date.toDateString()) < new Date(new Date().toDateString())
      );
    }

    function excludeDate(name) {
      var response =
        name !=
          "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" &&
        name != "Entrega Rápida - pedidos chegam em até 48hrs úteis";
      return response;
    }

    $.getJSON(
      "https://viacep.com.br/ws/" + $cep + "/json/?callback=?",
      function (dados) {
        if ("erro" in dados) {
          console.log("Erro na consulta, confira o cep e tente novamente");
          return;
        }

        switch (dados.uf) {
          case "AC":
            dados.uf = "Acre";
            break;
          case "AL":
            dados.uf = "Alagoas";
            break;
          case "AP":
            dados.uf = "Amapa";
            break;
          case "AM":
            dados.uf = "Amazonas";
            break;
          case "BA":
            dados.uf = "Bahia";
            break;
          case "CE":
            dados.uf = "Ceara";
            break;
          case "DF":
            dados.uf = "Distrito Federal";
            break;
          case "ES":
            dados.uf = "Espirito Santo";
            break;
          case "GO":
            dados.uf = "Goias";
            break;
          case "MA":
            dados.uf = "Maranhao";
            break;
          case "MT":
            dados.uf = "Mato Grosso";
            break;
          case "MS":
            dados.uf = "Mato Grosso do Sul";
            break;
          case "MG":
            dados.uf = "Minas Gerais";
            break;
          case "PA":
            dados.uf = "Para";
            break;
          case "PB":
            dados.uf = "Paraiba";
            break;
          case "PR":
            dados.uf = "Parana";
            break;
          case "PE":
            dados.uf = "Pernambuco";
            break;
          case "PI":
            dados.uf = "Piaui";
            break;
          case "RJ":
            dados.uf = "Rio de Janeiro";
            break;
          case "RN":
            dados.uf = "Rio Grande do Norte";
            break;
          case "RS":
            dados.uf = "Rio Grande do Sul";
            break;
          case "RO":
            dados.uf = "Rondonia";
            break;
          case "RR":
            dados.uf = "Roraima";
            break;
          case "SC":
            dados.uf = "Santa Catarina";
            break;
          case "SP":
            dados.uf = "Sao Paulo";
            break;
          case "SE":
            dados.uf = "Sergipe";
            break;
          case "TO":
            dados.uf = "Tocantins";
            break;
        }

        $.ajax({
          type: "GET", //rest Type
          dataType: "json", //mispelled
          url:
            "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" +
            $cep +
            "&shipping_address%5Bcountry%5D=" +
            "Brazil" +
            "&shipping_address%5Bprovince%5D=" +
            dados.uf,
          beforeSend: function () {
            //$('.overlay-carregando').show();
          },
          success: function (msg) {
            $shipping_list.html("");
            // $ship_name_display.html(msg.shipping_rates[0].name);
            // if($('.shipping-display.value') === 0.00){
            //   $('.shipping-display.value').html("Grátis");
            // }else{
            //   $('.shipping-display.value').html(Shopify.formatMoney(msg.shipping_rates[0].price, window.money_format));
            // }
            for (i = 0; i < msg.shipping_rates.length; i++) {
              var deliveryDate = msg.shipping_rates[i].delivery_date;

              var entrega = new Date(msg.shipping_rates[i].delivery_date);
              var checkBeforeday = isDateBeforeToday(entrega);
              var excludeDateCheck = excludeDate(msg.shipping_rates[i].name);
              let dataFormatada =
                entrega.getDate() +
                "/" +
                (entrega.getMonth() + 1) +
                "/" +
                entrega.getFullYear();

              let $formatedPrice;
              let $estimateShip;
              if (msg.shipping_rates[i].price === 0.0) {
                $formatedPrice = "Grátis";
              } else {
                $formatedPrice = Shopify.formatMoney(
                  msg.shipping_rates[i].price,
                  window.money_format
                );
              }
              var $priceShip = msg.shipping_rates[i].price;
              if (
                msg.shipping_rates[i].delivery_days[1] == null ||
                msg.shipping_rates[i].delivery_days[1] === 0
              ) {
                $estimateShip = "";
              } else {
                $estimateShip =
                  "Em até " +
                  msg.shipping_rates[i].delivery_days[1] +
                  " dias úteis";
              }

              if (
                (deliveryDate == null && excludeDateCheck) ||
                (checkBeforeday && excludeDateCheck)
              ) {
                entrega = "Estimativa de entrega indisponível";
              } else if (!excludeDateCheck) {
                if (
                  d.shipping_rates[i].name ==
                  "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis"
                ) {
                  entrega = "";
                } else {
                  entrega = "";
                }
              } 
              else {
                entrega = "<br/>(Estimativa de entrega: " + dataFormatada + ")";
              }
              // else {
              //   entrega = "";
              // }

              var $template =
                '<li data-shipping-change class="filters-group__list__item"> <label for="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" class="filters-checkbox"> <input type="radio" name="shipping_id" value="shippingId" id="shipping-option_' +
                msg.shipping_rates[i].name
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, "-")
                  .replace(/-$/, "")
                  .replace(/^-/, "") +
                '" data-name="' +
                msg.shipping_rates[i].name +
                '" data-price="' +
                msg.shipping_rates[i].price +
                '" data-formatted-price="' +
                $formatedPrice +
                '" data-delivery="' +
                $estimateShip +
                '"> <span class="check"></span> <span class="text" style="text-align: right;display: block;">' +
                $formatedPrice +
                " " +
                //entrega +
                "(" + $estimateShip + ")" +
                "</span> </label> </li>";

              $shipping_list.append($template);

              //$("#fretes-disponiveis > option[value='"+[i]+"']").attr("data-valor", msg.shipping_rates[i].price);
              $btn_calc.removeClass("is-loading");
            }
            // $display_shipping.removeClass('hidden');
            // $ship_name_display.removeClass('hidden');
            $shipping_list_container.removeClass("hidden");
          },
          error: function (erro) {
            error_ship_ajax("Não encontrou um frete?");
            $btn_calc.removeClass("is-loading");
          },
        });
      }
    );
  }

  function select_ship(selected) {
    var name = selected.data("name"),
      price = selected.data("price"),
      formated_price = selected.data("formatted-price"),
      delivery = selected.data("delivery");

    var $display_shipping = $(".shipping-display__wrapper"),
      $ship_name_display = $(".shipping-rate-name"),
      $ship_price_display = $(".shipping-display.value"),
      $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping");

    $ship_name_display.html(name);
    $ship_price_display.html(formated_price);

    $display_shipping.removeClass("hidden");
    $ship_name_display.removeClass("hidden");
    $shipping_list_container.addClass("hidden");
    $btn_calc.addClass("hidden");
    $btn_change.removeClass("hidden");
  }

  function show_rate_list() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options");
    $shipping_list_container.removeClass("hidden");
  }

  function reset_ship() {
    var $shipping_list_container = $(".cart-drawer__footer__shipping_options"),
      $display_shipping = $(".shipping-display__wrapper"),
      $btn_calc = $(".calculate-shipping"),
      $btn_change = $(".recalculate-shipping"),
      $input_cep = $(".zipcode-input");

    $shipping_list_container.addClass("hidden");
    $display_shipping.addClass("hidden");
    $btn_change.addClass("hidden");
    $btn_calc.removeClass("hidden");
    $input_cep.val("").focus();
  }

  $(document).on("click", ".calculate-shipping", function (e) {
    shipping_ajax();
  });

  $(document).on("click", ".recalculate-shipping", function (e) {
    reset_ship();
  });

  $(document).on("click", "[data-shipping-change]", function (e) {
    select_ship($(this).find("input"));
  });

  $(document).on("click", ".show-rates-list", function (e) {
    show_rate_list();
  });
})(jQuery);

// Heroica: rename Acessórios to Lifestyle (2026-07-29)
// Front-end label patch because the current Shopify app scope cannot edit Online Store navigation.
(function () {
  var FROM = 'Acessórios';
  var TO = 'Lifestyle';

  function replaceTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    if (node.nodeValue && node.nodeValue.indexOf(FROM) !== -1) {
      node.nodeValue = node.nodeValue.split(FROM).join(TO);
    }
  }

  function renameAccessories(root) {
    root = root || document;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue && node.nodeValue.indexOf(FROM) !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceTextNode);

    document.querySelectorAll('[data-list-link="' + FROM + '"], [aria-label="' + FROM + '"], [title="' + FROM + '"]').forEach(function (el) {
      if (el.getAttribute('data-list-link') === FROM) el.setAttribute('data-list-link', TO);
      if (el.getAttribute('aria-label') === FROM) el.setAttribute('aria-label', TO);
      if (el.getAttribute('title') === FROM) el.setAttribute('title', TO);
    });
  }

  function boot() {
    renameAccessories(document);
    setTimeout(function () { renameAccessories(document); }, 400);
    setTimeout(function () { renameAccessories(document); }, 1200);
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes && mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.TEXT_NODE) replaceTextNode(node);
            else if (node.nodeType === Node.ELEMENT_NODE) renameAccessories(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();



/* heroica-fix-pdp-inventory-quantity-2026-08-18
   Fix PDP add-to-cart stock guard on products where the theme puts
   data-inventory-quantity on the add button instead of the quantity input.
   Without this, theme.js compares max stock with NaN and blocks valid adds.
*/
(function () {
  function syncPdpInventoryQuantity() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    forms.forEach(function (form) {
      var quantityInput = form.querySelector('input[name="quantity"]');
      var addButton = form.querySelector('#product-add-to-cart, [data-btn-addtocart], button[name="add"], .product-form__submit');
      if (!quantityInput || !addButton) return;

      var buttonInventory = addButton.getAttribute('data-inventory-quantity');
      var inputInventory = quantityInput.getAttribute('data-inventory-quantity');

      if (buttonInventory && !inputInventory) {
        quantityInput.setAttribute('data-inventory-quantity', buttonInventory);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPdpInventoryQuantity);
  } else {
    syncPdpInventoryQuantity();
  }

  document.addEventListener('change', function (event) {
    if (event.target && (event.target.matches('input[name="id"]') || event.target.matches('select[name="id"]'))) {
      setTimeout(syncPdpInventoryQuantity, 0);
      setTimeout(syncPdpInventoryQuantity, 250);
    }
  });

  document.addEventListener('variant:change', function () {
    setTimeout(syncPdpInventoryQuantity, 0);
    setTimeout(syncPdpInventoryQuantity, 250);
  });

  setTimeout(syncPdpInventoryQuantity, 500);
  setTimeout(syncPdpInventoryQuantity, 1500);
})();
